import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'TEACHER_PROFILE_GET',
  GET_SUCCESS: 'TEACHER_PROFILE_GET_SUCCESS',
  GET_FAILURE: 'TEACHER_PROFILE_GET_FAILURE',

  POST: 'TEACHER_PROFILE_POST',
  POST_SUCCESS: 'TEACHER_PROFILE_POST_SUCCESS',
  POST_FAILURE: 'TEACHER_PROFILE_POST_FAILURE',

  PATCH: 'TEACHER_PROFILE_PATCH',
  PATCH_SUCCESS: 'TEACHER_PROFILE_PATCH_SUCCESS',
  PATCH_FAILURE: 'TEACHER_PROFILE_PATCH_FAILURE',

  INVALIDATE_ITEM: 'TEACHER_PROFILE_INVALIDATE_ITEM',
};

export const get = actions.get(
  teacherId => `${BASE_URL}/teachers/${teacherId}/profile/`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);

export const post = actions.post(
  (id, value, { teacherId }) => `${BASE_URL}/teachers/${teacherId}/profile/`,
  {
    PENDING: ACTIONS.POST,
    SUCCESS: ACTIONS.POST_SUCCESS,
    FAILURE: ACTIONS.POST_FAILURE,
  },
);

export const patch = actions.patch(
  teacherId => `${BASE_URL}/teachers/${teacherId}/profile/`,
  {
    PENDING: ACTIONS.PATCH,
    SUCCESS: ACTIONS.PATCH_SUCCESS,
    FAILURE: ACTIONS.PATCH_FAILURE,
  },
);

export const invalidateItem = id => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_ITEM,
    payload: { id },
  });
};
